<div class="not-allowed">
  <div *ngIf="heading"  class="col-12 m-0 p-0 d-flex  align-items-center" [ngClass]="label_align=='center'? 'justify-content-center':label_align=='right'?'justify-content-end': 'justify-content-start'" >
    <div class="m-0 p-0">
    <p class="float-none w-auto  m-0 d-flex align-items-center " [ngStyle]="headlineColor"  [ngClass]="labellPadding" >
      {{heading}}
    </p>
  </div>
  </div>
  <div *ngIf="isAndroid">
    <div
      class="card m-0 rounded bg-transparent p-0 shadow-none"
    >
      <img [src]="emptyImage" class="card-img" alt="empty" [style]="'height: ' + cellHeight" [ngStyle]="{'height': fontSmaller ? '16px': '38px'}">
      <div class="card-img-overlay p-0 d-flex justify-content-center">
        <div class="row m-0 p-0 d-flex justify-content-center align-items-center w-100" [ngClass]="fontSmaller?'p-0':'p-1'">
          <div *ngIf="leading_icon" class="col-1 m-0 px-0  d-flex justify-content-center ">
            <i class="float-none w-auto m-0 d-flex align-items-center" [ngStyle]="leadingIconColor" [ngClass]="sublabelPadding"  [class]="builderService.getIcon(leading_icon).type=='mir'?'material-icons-outlined':'material-icons'">
              {{ builderService.getIcon(leading_icon).id }}
            </i>
          </div>
          <div  [ngClass]="leading_icon? trailing_icon? 'col-10':'col-11':  trailing_icon?'col-11':'col-12'"  class="m-0 p-0 d-flex align-items-center justify-content-center h-100" >
            <div *ngIf="!range" class="w-100 position-relative" [ngStyle]="colorsMain">
              <input
              class="w-100 not-allowed"
              [ngClass]="class"
              type="range"
              [id]="rangeId"
              [(ngModel)]="sliderValue"
              [min]="minValue"
              [max]="maxValue"
              [step]="step"
              (input)="updateBackground()"
              disabled
              />

              <!-- <div class="position-absolute d-flex align-items-center justify-content-between top-0 start-0 end-0 bottom-0 p-1" style="height: 16px;" *ngIf="showDots">
                <div class="bg-black rounded-circle" style="width: 4px; height: 4px;" *ngFor="let item of steps; let i = index" [ngClass]="{'active-dot': i === activeDotIndex}"></div>
              </div> -->
            </div>
            <div *ngIf="range && minValue != null && maxValue != null && valueStart != null && valueEnd != null" class="wrapper" [ngStyle]="colorsMain">
              <div class="range-slider" [id]="rangeId">

                <input type="range" [min]="minValue" [value]="valueStart" [max]="maxValue" name="" id="">
                <input type="range" [min]="minValue" [value]="valueEnd" [max]="maxValue" name="" id="">

                <div class="track-wrapper">
                  <div class="track"></div>
                  <div class="range-between"></div>
                  <div class="thumb left"></div>
                  <div class="thumb right"></div>
                </div>
              </div>
            </div>
            <!-- <md-slider labeled [range]="range" [ticks]="ticks" [step]="step" [min]="minValue" [max]="maxValue" [valueStart]="valueStart" [valueEnd]="valueEnd" [value]="sliderValue" class="w-100" style="cursor: not-allowed; pointer-events: none !important;" [ngStyle]="colorsMain"></md-slider> -->
          </div>
          <div *ngIf="trailing_icon" class="col-1 m-0 p-0 d-flex justify-content-center" >
            <i class="float-none w-auto m-0 d-flex align-items-center" [ngStyle]="traillingIconColor" [ngClass]="sublabelPadding"  [class]="builderService.getIcon(trailing_icon).type=='mir'?'material-icons-outlined':'material-icons'">
              {{ builderService.getIcon(trailing_icon).id }}
            </i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!isAndroid">
    <div
      class="card m-0 rounded bg-transparent p-0 shadow-none"
    >
      <img [src]="emptyImage" class="card-img" alt="empty" [style]="'height: ' + cellHeight" [ngStyle]="{'height': fontSmaller ? '16px': '38px'}">
      <div class="card-img-overlay p-0 d-flex justify-content-center">
        <div class="row m-0 p-0 d-flex justify-content-center align-items-center w-100" [ngClass]="fontSmaller?'p-0':'p-1'">
          <div *ngIf="leading_icon" class="col-1 m-0 px-0  d-flex justify-content-center ">
            <i class="float-none w-auto m-0 d-flex align-items-center" [ngStyle]="leadingIconColor" [ngClass]="sublabelPadding"  [class]="builderService.getIcon(leading_icon).type=='mir'?'material-icons-outlined':'material-icons'">
              {{ builderService.getIcon(leading_icon).id }}
            </i>
          </div>
          <div  [ngClass]="leading_icon? trailing_icon? 'col-10':'col-11':  trailing_icon?'col-11':'col-12'"  class="m-0 p-0 d-flex align-items-center justify-content-center h-100" >

            <md-slider [range]="range" [ticks]="ticks" [step]="step" [min]="minValue" [max]="maxValue" [valueStart]="valueStart" [valueEnd]="valueEnd" [value]="sliderValue" class="w-100" style="cursor: not-allowed; pointer-events: none !important;" [ngStyle]="colorsMain"></md-slider>
          </div>
          <div *ngIf="trailing_icon" class="col-1 m-0 p-0 d-flex justify-content-center" >
            <i class="float-none w-auto m-0 d-flex align-items-center" [ngStyle]="traillingIconColor" [ngClass]="sublabelPadding"  [class]="builderService.getIcon(trailing_icon).type=='mir'?'material-icons-outlined':'material-icons'">
              {{ builderService.getIcon(trailing_icon).id }}
            </i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
